import React from "react";
import clsx from "clsx";
import { AutoSizer } from "react-virtualized";
import MuiVirtualizedTable, {
  VirtualizedTableProps,
} from "./MuiVirtualizedTable";
import { useAutoSizedTableStyles } from "./styles";

const AutoSizedTable = (props: VirtualizedTableProps) => {
  const classes = useAutoSizedTableStyles();

  return (
    <AutoSizer>
      {({ height, width }) => (
        <MuiVirtualizedTable
          {...props}
          height={height}
          width={width}
          tableClassName={clsx(classes.table, props.tableClassName)}
        />
      )}
    </AutoSizer>
  );
};

export default AutoSizedTable;
